
import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import { t } from 'i18next';
import { useCallback, useEffect, useRef, useState } from 'react'
import CustomStore from 'devextreme/data/custom_store';
import React from 'react';
import { DataGrid, Drawer} from 'devextreme-react';
import { productSupplyParamService } from '../services/product_supply_parameter-service';
import { DataGridTypes } from 'devextreme-react/cjs/data-grid';
import { toast } from 'react-toastify';
import product_supply_parameter_grid from './product_supply_parameter_grid'
import ProductSupplyParameterQuery from './product_supply_parameter_query'
import GridToolbar from '../components/grid_tool_bar';
import DataGridWrapper from '../components/data-grid-wrapper';
const ProductSupplyParameter = () => {
    let supplierCode: string;
    let locationCode: string;
    let productCode: string;
    const dataGridRef = useRef<DataGrid>(null);   
    const queryRef=useRef<any>(null);
    const [store, setStore] = useState<CustomStore>();

    
    useEffect(() => {
        setStore(new CustomStore({
            key: ['id'], 
            load: load_grid_data,
            update: productSupplyParamService.updateProductSupplyParameter,
            useDefaultSearch: true
        }));
    }, [])

    const load_grid_data = useCallback(async () => {
        const x = await productSupplyParamService.getProductSupplyParameter(supplierCode, locationCode, productCode);
        return x;
    }, []);

    const save_grid_data = (e: DataGridTypes.SavingEvent) => {
        e.cancel = true;
        if (e.changes.length > 0) {

            productSupplyParamService.updateProductSupplyParameterBatch(e.changes).then((response) => {
                toast.success(t("syncflow:msg_saved"));
            });

        }
    }        

    /*Query*/
    const query_changed = useCallback((vendor_code:any,location_code:any,product_code:any) => {        
        supplierCode=vendor_code;
        locationCode=location_code;
        productCode=product_code;
        console.log(supplierCode);
    }, []);
    
    //const on_query_clear = useCallback(async () => {queryRef.current?.clear();}, []);
    const checkPermission=()=>{return {canRemove:false,canAddNew:false}}
    return (
        <>
      
       <div className="card">
        <div className="card-body">
        <ProductSupplyParameterQuery onchaged={query_changed}  ref={queryRef}   />
        </div>
        </div>
            
            
            <React.Fragment>
                <DataGridWrapper
                    props={{ ref: dataGridRef }}
                    datasource={store}
                    remoteOperations={false}
                    showColumnLines={true}
                    columnChooser={true}                    
                    onEditingStart={product_supply_parameter_grid.onEditingStart}
                    onSaving={save_grid_data}
                    pagerVisible={true}
                    filterVisible={false}
                    headerFilterVisible={true}
                    selectionConfig={{ mode: 'multiple', selectAllMode: 'allPages', showCheckBoxesMode: 'always' }}
                    keyboardNavigation={true}
                    customToolbarContent={ GridToolbar({gridRef:dataGridRef,canAddNew:false,canRemove:false,CheckPermision:checkPermission,canChoseColumn:false})} 
                    editingConfig={{
                        mode: "batch",
                        useIcons: true,
                        allowAdding: true,
                        allowDeleting: false,
                        allowUpdating: true,
                        updateMessageText: RemoveMessage('Resource')                       
                    }}
                    columns={[
                        {
                            dataField: 'vendorName',
                            caption: t('syncflow:supplier'),
                            allowFiltering: true,
                            allowEditing: true,
                            customRequired: false,  
                            editCellRender:product_supply_parameter_grid.vendor_cell_render,                                                     
                        },
                        // {
                        //     dataField: 'locationName',
                        //     caption: t('syncflow:location'),
                        //     allowFiltering: true,
                        //     allowEditing: true,  
                        //     editCellRender:product_supply_parameter_grid.location_cell_render,
                        // },
                        {
                            dataField: 'productName',
                            caption: t('syncflow:lb_product_name'),
                            allowFiltering: true,
                            allowEditing: true ,  
                            editCellRender:product_supply_parameter_grid.product_cell_render,                                                                                 
                        },
                        {
                            dataField: 'minOrderQty',
                            caption: t('syncflow:min_order_qty'),
                            allowFiltering: true,
                            allowEditing: true,
                           
                        },
                        {
                            dataField: 'maxOrderQty',
                            caption: t('syncflow:max_order_qty'),
                            allowFiltering: true,
                            allowEditing: true,
                        },
                        {
                            dataField: 'purchaseUnitQty',
                            caption: t('syncflow:purchase_unit_qty'),
                            allowFiltering: true,
                            allowEditing: true,
                        },
                        {
                            dataField: 'measurementUnit',
                            caption: t('syncflow:measurement_unit'),
                            allowFiltering: true,
                        },
                        {
                            dataField: 'isPurchasable',
                            caption: t('syncflow:is_purchasable'),
                            allowFiltering: true,
                            allowEditing: false,
                        }
                    ]}
                />
            </React.Fragment>
        </>
    )
}
export default ProductSupplyParameter